import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('graphql', {
  library: 'apollo-link-hub-http',
});
